import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_3 = { class: "text-xl text-center mb-1 pb-0" }
const _hoisted_4 = { class: "font-dmsans mb-3 text-lighterDark" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_8 = { class: "text-xl text-center mb-1 pb-0" }
const _hoisted_9 = { class: "font-bold text-mainDark" }

import { IonContent, IonModal } from '@ionic/vue'
import { useEvents } from '@/composables/events'
import { useGwModal } from '@/plugins/gw-modal'
import GwBottomSheet from '@/plugins/gw-modal/GwBottomSheet.vue'
import GwModal from '@/plugins/gw-modal/GwModal.vue'
import { useModal } from '@/composables/modal'
import { nextTick, onMounted, reactive, ref, watch } from 'vue'
import { Form } from 'vee-validate'
import { IonSpinner } from '@ionic/vue'
import GwInput from '@/components/GwInput.vue'
import GwApiErrors from '@/plugins/gw-api-errors/GwApiErrors.vue'
import { useStore } from 'vuex'
import { State } from '@/store'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useApi } from '@/plugins/api'
import { useEventHandlers } from '@/composables/eventHandlers'
import FixedBottomControls from '@/components/modals/parts/FixedBottomControls.vue'
import { useFixedBottom } from '@/composables/fixedBottom'
import { useIonContent } from '@/composables/ionContent'
import { useGWAnalytics } from '@/plugins/analytics'
import { useGWAnalyticsBasePayload } from '@/plugins/analytics/composables/analyticsBasePayload'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetModal',
  setup(__props) {

const gwModal = useGwModal()
const { modalOpen, modalType } = useModal('reset')
const { modalEventBus } = useEvents()
const back = ref(false)

watch(modalOpen, (val) => {
	if (val) back.value = false
})

const onModalWillDismiss = () => modalEventBus.emit('close', { 
	data: {
		hookCondition: back.value
	},
	type: 'reset'
})
const onModalDismiss = (data: any) => {
	modalOpen.value = false
	modalEventBus.emit('closed', { 
		data: {
			detail: data?.detail,
			hookCondition: back.value
		},
		type: 'reset',
	})
}

const store = useStore<State>()
const form = reactive({ email: ref('') })
onMounted(async () => {
  if (store.state.user.email) {
    await nextTick()
    form.email = store.state.user.email
  }
})

const { clickDelay } = useEventHandlers()
const { track, vAnalyticsClick } = useGWAnalytics()
const { payload } = useGWAnalyticsBasePayload()
const { t } = useI18n()
const route = useRoute()
const onInvalidSubmit = ({ errors }: { errors: any }) => {
  track('form_error', {
		...payload.value,
    form_name: `PasswordReset - ${Object.keys(errors).join(', ')}`,
		value: Object.keys(errors).join(', ')
  })
}

const processing = ref(false)
const sent = ref(false)
const api = useApi()
const formRef = ref(null)
const error = ref<any>(undefined)
const reset = async () => {
  processing.value = true
  try {
    await api.auth.forgot({ email: form.email })
    sent.value = true
  } catch (err: any) {
    console.error(err)
    const form = formRef.value as any
    form?.setTouched({ email: false })
    error.value = err.response
  } finally {
    processing.value = false
  }
}

const emailInput = ref()
const inputFocused = ref(false)
const fixedDismissButton = ref(true)
const { fixedPaddingBottom, onFixedBottomResize } = useFixedBottom()
const { scrollIonContentToElement } = useIonContent()
const onInputFocus = async (content: InstanceType<typeof IonContent>, input: any) => {
	if ((window as any).__firefox__ || /firefox|fxios/i.test(navigator.userAgent)) {
		inputFocused.value = true
		fixedDismissButton.value = false
		scrollIonContentToElement(content, (input.$el as HTMLElement))
	}
}

const onInputBlur = () => {
	inputFocused.value = false
	fixedDismissButton.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(_unref(IonModal), {
    id: "ResetModal",
    animated: true,
    class: _normalizeClass(_unref(modalType) === 'bottomSheet' ? 'gw-modal-sheet' : ''),
    "enter-animation": _unref(modalType) === 'overlay' ? _unref(gwModal).enterAnimationDefinition : undefined,
    "leave-animation": _unref(modalType) === 'overlay' ? _unref(gwModal).leaveAnimationDefinition : undefined,
    "is-open": _unref(modalOpen),
    breakpoints: _unref(modalType) === 'bottomSheet' ? [0,1] : undefined,
    "initial-breakpoint": _unref(modalType) === 'bottomSheet' ? 1 : undefined,
    "can-dismiss": true,
    onWillDismiss: onModalWillDismiss,
    onDidDismiss: onModalDismiss
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(modalType) === 'bottomSheet' ? GwBottomSheet : GwModal), {
        "fixed-dismiss-button": fixedDismissButton.value,
        name: "ResetModal"
      }, {
        default: _withCtx(({ content }) => [
          _createElementVNode("div", {
            class: "w-full",
            style: _normalizeStyle((inputFocused.value || sent.value) ? undefined : { 'padding-bottom': _unref(fixedPaddingBottom) })
          }, [
            _createElementVNode("img", {
              src: sent.value ? require('@/assets/mail.svg') : require('@/assets/passcode-lock.svg'),
              class: "gw-main-icon h-[50px] w-[52px] rounded-md mx-auto"
            }, null, 8, _hoisted_1),
            (!sent.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)("change_of_your_password")), 1),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("change_password_instructions")), 1),
                  _createVNode(_unref(Form), {
                    ref_key: "formRef",
                    ref: formRef,
                    class: "w-full",
                    onInvalidSubmit: onInvalidSubmit
                  }, {
                    default: _withCtx(({ handleSubmit, meta }) => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(GwInput, {
                          ref_key: "emailInput",
                          ref: emailInput,
                          modelValue: form.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
                          class: "mt-3",
                          name: "email",
                          type: "email",
                          label: _unref(t)('login.form.labels.email'),
                          rules: "required|email",
                          onFocus: () => onInputFocus(content, emailInput.value),
                          onBlur: onInputBlur,
                          onKeyupEnter: () => handleSubmit(reset)
                        }, null, 8, ["modelValue", "label", "onFocus", "onKeyupEnter"]),
                        _createVNode(GwApiErrors, {
                          meta: meta,
                          error: error.value
                        }, null, 8, ["meta", "error"])
                      ]),
                      _createVNode(FixedBottomControls, {
                        class: _normalizeClass({ '!relative !px-0': inputFocused.value }),
                        onResize: _unref(onFixedBottomResize)
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            class: "gw-button -primary relative",
                            disabled: processing.value,
                            onClick: _withModifiers(($event: any) => (_unref(clickDelay)(() => handleSubmit(reset))), ["prevent"])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(processing.value ? 'opacity-0' : '')
                            }, _toDisplayString(_unref(t)("send_instructions")), 3),
                            (processing.value)
                              ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                                  key: 0,
                                  class: "absolute text-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                                  name: "crescent"
                                }))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_6)), [
                            [_unref(vAnalyticsClick), _unref(route)]
                          ]),
                          _createElementVNode("button", {
                            class: "gw-button -secondary",
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {_unref(clickDelay)(() => { back.value = true; onModalWillDismiss() })}, ["prevent"]))
                          }, _toDisplayString(_unref(t)("back_to_login")), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "onResize"])
                    ]),
                    _: 2
                  }, 1536)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(t)("check_your_email")), 1),
                  _createVNode(_component_i18n_t, {
                    keypath: "reset_password_email_instructions_sent",
                    tag: "span",
                    class: "text-base text-lighterDark mb-8",
                    scope: "global"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(form.email), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("button", {
                    class: "gw-button -secondary",
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(clickDelay)(() => onModalWillDismiss())), ["prevent"]))
                  }, _toDisplayString(_unref(t)("system.close")), 1)
                ]))
          ], 4)
        ]),
        _: 1
      }, 8, ["fixed-dismiss-button"]))
    ]),
    _: 1
  }, 8, ["class", "enter-animation", "leave-animation", "is-open", "breakpoints", "initial-breakpoint"]))
}
}

})